import React, { useContext } from 'react'
import { UserContext } from '../contexts/UserContext'
import { Navigate, Outlet } from 'react-router-dom';

function IndividualRoute ( { element: Element, ...rest } )
{
    const { loggedInUserDetails } = useContext( UserContext )

    if ( !loggedInUserDetails.isOrganization )
    {
        return ( <Outlet /> )
    }
    else
    {
        return <Navigate to="/user" />;
    }
}

export default IndividualRoute